export enum ERROR_USECASE_ID {
  noSiteAccess = 'NO_SITE_ACCESS',
  siteExpired = 'SITE_EXPIRED',
  subscriptionExpired = 'SUBS_LIMIT_OVER',
  noAdminAccess = 'NO_ADMIN_ACCESS',
  TechnicalGlitch = 'TECHNICAL_GLITCH',
  tokenInvalid = 'FTP_APP_TOKEN_INVALID',
}
